import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import {
  getInspectionResutlBackground,
  getInspectionResutlColor,
  getInspectionResutlSymbol,
} from "../../utils/display-utils";
import { Button } from "../../components";
import { fetchJudgmentStatus } from "../../api/status/inspection-apis";
import { formatDate, isPast } from "../../utils/datetime-utils";
import JudgmentArrow from "../../assets/icons/judgment-arrow.svg";
import { useNavigate } from "react-router-dom";
import { JUDGMENT } from "../../constants/routes";

export default function JudgmentResult({
  result,
  machine,
  panelState,
  setPanelState,
  setShowModal,
  type,
}) {
  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  const [isDailyResultSelected, setIsDailyResultSelected] = useState(false);
  const [isMonthlyResultSelected, setIsMonthlyResultSelected] = useState(false);
  const [judgmentStatus, setJudgmentStatus] = useState();
  const [style, setStyle] = useState();

  // const updateState = () => {
  //   if (
  //     (result?.judgment_result === -1 ||
  //       result?.judgment_result === undefined) &&
  //     !result?.judgment_remaining
  //   ) {
  //     return;
  //   }
  //   if (
  //     (isDailyResultSelected && type === "daily") ||
  //     (isMonthlyResultSelected && type === "monthly")
  //   ) {
  //     setPanelState({
  //       day: 0,
  //       machine: "",
  //       dailyJudgment: false,
  //       monthlyJudgment: false,
  //       dailyInspection: false,
  //     });
  //     return;
  //   }
  //   const newState = {
  //     ...panelState,
  //     day: type === "daily" ? result?.inspection_day : 0,
  //     machine: machine,
  //     dailyJudgment: type === "daily",
  //     monthlyJudgment: type === "monthly",
  //   };
  //   setPanelState(newState);
  // };

  // useEffect(() => {
  //   if (
  //     (result !== undefined && isDailyResultSelected && type === "daily") ||
  //     (result !== undefined && isMonthlyResultSelected && type === "monthly")
  //   ) {
  //     const params = {
  //       workflow: result.workflow,
  //       inspection: result.id,
  //     };
  //     fetchJudgmentStatus(params)
  //       .then((response) => {
  //         setJudgmentStatus(response.data?.judgments);
  //       })
  //       .catch((e) => {
  //         setJudgmentStatus([]);
  //       });
  //   }
  // }, [result, isDailyResultSelected, isMonthlyResultSelected, type]);

  useEffect(() => {
    const color = getInspectionResutlColor(
      result?.judgment_result,
      resultSymbolSetting,
      result?.not_inspect
    );
    if (
      panelState?.day === result?.inspection_day &&
      panelState?.dailyInspection &&
      panelState?.machine === machine
    ) {
      setStyle({
        color: color,
        background: "#feec88",
      });
    } else {
      setStyle({
        color: color,
        background: getInspectionResutlBackground(
          result?.judgment_result,
          resultSymbolSetting,
          result?.not_inspect,
          true
        ),
      });
    }
  }, [panelState, result?.day]);

  // useEffect(() => {
  //   setIsDailyResultSelected(
  //     panelState.day === result?.inspection_day &&
  //       panelState.machine === machine &&
  //       panelState.dailyJudgment
  //   );
  //   setIsMonthlyResultSelected(
  //     panelState.machine === machine && panelState.monthlyJudgment
  //   );
  // }, [panelState, result, machine]);

  const handleShowInspection = () => {
    if (result === undefined || (result?.inspection_result === -1 && result.not_inspect)) {
      return;
    }
    setPanelState((state) => ({
      ...state,
      day: result?.inspection_day,
      dailyJudgment: false,
      monthlyJudgment: false,
      dailyInspection: true,
      inspection: result?.id,
      workflow: result?.workflow,
      machine: machine,
    }));
    setShowModal(true);
  };

  return (
    <div className={`relative ${type === "monthly" ? "w-full" : "w-1/2"}`}>
      <div
        className="text-center w-full"
        onClick={() => handleShowInspection()}
      >
        {result?.judgment_result === -1 ||
        result?.judgment_result === undefined ? (
          result?.not_inspect ? (
            <div
              style={style}
              className="h-[40px] flex items-center justify-center bg-white"
            >
              <span>
                {getInspectionResutlSymbol(
                  result?.judgment_result,
                  resultSymbolSetting,
                  result?.not_inspect
                )}
              </span>
            </div>
          ) : (
            <div
              style={
                result?.judgment_remaining
                  ? {
                      color: resultSymbolSetting?.failed.color,
                      background: resultSymbolSetting?.failed.background,
                    }
                  : {}
              }
              className={`h-[40px] flex items-center justify-center bg-white ${
                result?.judgment_remaining
                  ? "cursor-pointer hover:!bg-[#feec88]"
                  : ""
              }`}
            >
              {result?.judgment_remaining ? resultSymbolSetting?.failed.symbol : ""}
            </div>
          )
        ) : (
          <div
            style={style}
            className="cursor-pointer hover:!bg-[#feec88] h-[40px] flex items-center justify-center bg-white"
          >
            <span>
              {getInspectionResutlSymbol(
                result?.judgment_result,
                resultSymbolSetting
              )}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

const JudgmentResultPanel = ({
  judgmentStatus,
  day,
  result,
  setPanelState,
  panelState,
}) => {
  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  const navigate = useNavigate();
  const panelRef = useRef(null);
  const position =
    day < 15
      ? "top-[40px] left-[29px]"
      : day < 32
      ? "top-[40px] right-[29px]"
      : "top-[40px] right-[72px]";

  const handleNavigate = (judgmentData) => {
    navigate(
      `${JUDGMENT}?inspection=${result?.id}&workflow=${result?.workflow}`
    );
  };

  const handleOutside = (e) => {
    if (panelRef.current && !panelRef.current.contains(e.target)) {
      setPanelState({
        day: 0,
        machine: "",
        dailyJudgment: false,
        monthlyJudgment: false,
        dailyInspection: false,
      });
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutside);
    document.addEventListener("touchstart", handleOutside);
    return () => {
      document.removeEventListener("click", handleOutside);
      document.removeEventListener("touchstart", handleOutside);
    };
  }, []);
  return (
    judgmentStatus && (
      <div
        className={`absolute text-[16px] text-center z-10 ${position}`}
        ref={panelRef}
      >
        <div className="bg-white border-b border-t border-tenken-gray-500">
          <div className="w-full p-[4px] text-center border-l border-r border-tenken-gray-500 bg-tenken-gray-300">
            日常承認状況
          </div>
          <div className="flex border-t border-r border-tenken-gray-500">
            {judgmentStatus &&
              judgmentStatus?.map((judgment) => (
                <div className="w-fit">
                  <div className="flex gap-0">
                    <div className="w-[160px] border-l border-tenken-gray-500">
                      <div className="w-full p-[4px] text-center bg-tenken-gray-300 border-b border-tenken-gray-500">
                        {judgment.incharge_name}
                      </div>
                      <div className=" h-[160px] px-[24px] pt-[10px] pb-[20px]">
                        <div className="w-full flex justify-center items-center h-[60px]">
                          {judgment.result === 1 && (
                            <div>
                              <img src={JudgmentArrow} alt="judged" />
                            </div>
                          )}
                        </div>
                        {!judgment.can_rejudgment &&
                          !judgment.can_rejudgment &&
                          judgment.result >= 0 && (
                            <div className="mt-[10px] h-[30px] flex justify-center">
                              <div
                                className="px-auto w-[24px]"
                                style={{
                                  color: getInspectionResutlColor(
                                    judgment?.result,
                                    resultSymbolSetting
                                  ),
                                  background: getInspectionResutlBackground(
                                    judgment?.result,
                                    resultSymbolSetting
                                  ),
                                }}
                              >
                                <span className="inline-block">
                                  {getInspectionResutlSymbol(
                                    judgment.result,
                                    resultSymbolSetting
                                  )}
                                </span>
                              </div>
                              <span className="ml-1">
                                {judgment.result === 1 ? "承認" : "差し戻し"}
                              </span>
                            </div>
                          )}
                        <div className="w-full flex justify-center items-center">
                          {judgment.can_rejudgment && (
                            <Button
                              color="yellow"
                              className="w-[112px]"
                              onClick={() => handleNavigate(judgment)}
                            >
                              再判定
                            </Button>
                          )}
                          {judgment.can_judgment && (
                            <Button
                              color="red"
                              className="w-[112px]"
                              onClick={() => handleNavigate(judgment)}
                            >
                              判定
                            </Button>
                          )}
                        </div>
                        <div className="mt-[10px] w-full text-center p-2">
                          {judgment?.judgment_datetime &&
                            formatDate(judgment.judgment_datetime)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    )
  );
};
